import config from "../branding/default/js/config";

const date = new Date();
export const year = date.getFullYear();

export const setPageTitle = (parts, appendAppOwner = true) => {
  parts = typeof parts === "object" ? parts : [parts];
  if (appendAppOwner) {
    parts.push(config.text("common.appOwner"));
  }
  document.title = parts.join(" - ");
};



// WEBPACK FOOTER //
// ./src/misc/helpers.js